export const SET_SIGNUP_TOKEN = 'SET_SIGNUP_TOKEN';
export const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN';
export const SET_APPLICANT = 'SET_APPLICANT';
export const EMAIL_VERIFY = 'EMAIL_VERIFY';
export const INIT_STATE = 'INIT_STATE';
export const SET_API_ENUMS = 'SET_API_ENUMS';
